<template>
	<div>
        <le-pagview @setData="setTableData" :pageParam="pageParam" v-if="pageParam" style="margin-top: 0px !important;">
            <el-table :data="tableData" :highlight-current-row="true" max-height="510" class="zdxx-table">
                <el-table-column label="操作时间">
                    <template slot-scope="{ row }">
                        <span> {{ row.opDateStr }}&nbsp;{{ row.opTimeStr }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="生效时间">
                    <template slot-scope="{ row }">
                        <span> {{ row.opDateStr }}&nbsp;{{ row.opTimeStr }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="操作类型" >
                    <template slot-scope="{ row }">
                        <span> {{ row.type == 0 ? '项目' : '物业合同' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="操作内容" min-width="300">
                    <template slot-scope="{ row }">
                        <span> {{ row.comment || '' }}</span>
                    </template>
                </el-table-column>
                
                <el-table-column prop="description" label="变更后内容">
                    <template slot-scope="{ row }">
                        <span class="a-c-blue font-point" @click="showChangeContent(row)" v-if="row.newDetail || row.oldDetail">查看</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="当前状态">
                    <template slot-scope="{ row }">
                        <span>{{ row.toStateText || '' }}</span>
                        <span v-if="row.incomeConfirmStatus">、{{ util.initDic(row.incomeConfirmStatus, 'incomeConfirmStatus') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="opUserRealName" label="操作人">
                    <template slot-scope="{ row }">
                        <span> {{ row.opUserRealName || '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="备注">
                    <template slot-scope="{ row }">
                        <span> {{ row.description || '' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="1000px">
            <div class="formContent">
                <el-table :data="changeTableData">
                    <el-table-column label="">
                        <template slot-scope="{ row }">
                            <span>{{ row.changeItemName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="修改前">
                        <template slot-scope="{ row }">
                            <span v-if="row.keyVal != 'targetList'">{{ row.oldVal || '-' }}</span>
                            <div v-else class="income-detail a-w-100">
                                <div class="income-group" v-for="(item,index) in row.oldVal" :key="index">
                                    <div class="income-card income-card-parent">
                                        <span class="card-name">{{ item.targetCompanyName }}</span>
                                        <span class="card-ratio">{{ (item.rate / 100).toFixed(2) }}%</span>
                                    </div>
                                    <div class="children-wrap" v-if="item.childList && item.childList.length">
                                        <div class="child-wrap" v-for="(child,cIdx) in item.childList" :key="cIdx">
                                            <div class="income-card income-card-child">
                                                <span class="card-name">{{ child.targetCompanyName }}</span>
                                                <span class="card-ratio">{{ (child.rate / 100).toFixed(2) }}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="修改后">
                        <template slot-scope="{ row }">
                            <span v-if="row.keyVal != 'targetList'">{{ row.newVal || '-' }}</span>
                            <div v-else class="income-detail a-w-100">
                                <div class="income-group" v-for="(item,index) in row.newVal" :key="index">
                                    <div class="income-card income-card-parent">
                                        <span class="card-name">{{ item.targetCompanyName }}</span>
                                        <span class="card-ratio">{{ (item.rate / 100).toFixed(2) }}%</span>
                                    </div>
                                    <div class="children-wrap" v-if="item.childList && item.childList.length">
                                        <div class="child-wrap" v-for="(child,cIdx) in item.childList" :key="cIdx">
                                            <div class="income-card income-card-child">
                                                <span class="card-name">{{ child.targetCompanyName }}</span>
                                                <span class="card-ratio">{{ (child.rate / 100).toFixed(2) }}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <approvalTimeline :instanceId="currentRow.approvalInstanceId" v-if="currentRow.approvalInstanceId"></approvalTimeline>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
    import util from '../../utils/util'
    import approvalTimeline from './child/approval-timeline.vue';
	export default {
        components: {
            approvalTimeline
        },
		props: {
			incomeId: {
				type: Number,
			},
		},
		computed: {
			...mapState({
				company: state => state.company.company,
			})
		},
		data() {
			return {
                util,
				pageParam: '',
				tableData: [],
                changeTableData: [],
                changeContentKeys: {
                    'name':'项目名称',
                    'companyName':'所属商户',
                    'serviceFee':'服务费',
                    'needConfirm':'是否需要三方确认',
                    'incomeType':'入账类型',
                    'defaultPlanName':'计费模板',
                    'electricCompanyName':'所属商户',
                    'electricUnitPrice':'电费单价',
                    'rateType':'分成模式',
                    'contractFile':'物业合同',
                    'surveyAreaName':'合同关联现勘',
                    'startTimeText':'生效日期',
                    'endTimeText':'结束日期',
                    'targetList': '收益方',
                    'contractNote': '合同说明',
                    'endDate': '结束日期',
                    'startDate': '开始日期',
                    'payPlatform': '收益钱包'
                },
                dialogVisible: false,
                title: '',
                currentRow: {}
			}
		},
		watch: {

			incomeId: {
				handler(val) {
					if (val) {
						this.pageParam = {
							url: this.$Config.apiUrl.getIncomeTimeLine,
							method: "get",
							params: {
								incomeId: this.incomeId
							},
							freshCtrl: 1,
						}
					}
				},
				immediate: true
			},

		},
        mounted () {
        },
		methods: {
			setTableData(data) {
				this.tableData = data.data.map(res=>{
                    let incomeConfirmStatus = ''
                    try{
                        incomeConfirmStatus = JSON.parse(res.oldDetail).confirmStatus
                    }catch(e){
                        incomeConfirmStatus = ''
                    }
					return {
						...res,
						incomeConfirmStatus: incomeConfirmStatus
					}
				})
			},
            showChangeContent (row) {
                this.currentRow = row
                try {
                    let changeContent = JSON.parse(row.newDetail)
                    let changeContentOld = row.oldDetail ? JSON.parse(row.oldDetail) : {}
         
                    let changeTableData = []
                    for (const key in this.changeContentKeys) {
                        if (Object.hasOwnProperty.call(this.changeContentKeys, key)) {
                            let newVal = changeContent[key] || '', oldVal = changeContentOld[key] || ''
                            if(key == 'electricUnitPrice' || key == 'serviceFee') {
                                newVal = newVal ? (newVal / 100).toFixed(2) : '0.00'
                                oldVal = oldVal ? (oldVal / 100).toFixed(2) : '0.00'
                            }
                            if(key == 'incomeType') {
                                newVal = util.initDic(newVal, 'incomeType')
                                oldVal = util.initDic(oldVal, 'incomeType')
                            }
                            if(key == 'needConfirm') {
                                newVal = newVal ? '需要' : '不需要'
                                oldVal = oldVal ? '需要' : '不需要'
                            }
                            if(key == 'rateType') {
                                let rateTypeDic = {
                                    1: '固定收益比例',
                                    2: '浮动收益比例'
                                }
                                newVal = rateTypeDic[newVal] || '-'
                                oldVal = rateTypeDic[oldVal] || '-'
                            }
                   
                            let isChange = changeContent[key] == changeContentOld[key] ? false : true
                            if(key == 'targetList') {
                                // 长度比较与非数组防御已在 arraysEqual 内部处理，直接调用（含下级 childList）
                                isChange = this.arraysEqual(newVal, oldVal)
                            }
                            if(key == 'startDate') {
                                newVal = newVal ? this.$getDay.getTimeStampToStr(newVal, 'YYYY-MM-DD') : '-'
                                oldVal = oldVal ? this.$getDay.getTimeStampToStr(oldVal, 'YYYY-MM-DD') : '-'
                            }
                            if(key == 'endDate') {
                                newVal = newVal ? this.$getDay.getTimeStampToStr(newVal, 'YYYY-MM-DD') : '-'
                                oldVal = oldVal ? this.$getDay.getTimeStampToStr(oldVal, 'YYYY-MM-DD') : '-'
                            }
                            if(key == 'payPlatform') {
								let newValText = newVal ? util.initDic(newVal.servicePlatform, 'servicePlatform') : '-'
								let oldValText = oldVal ? util.initDic(oldVal.servicePlatform, 'servicePlatform') : '-'
								if(newVal.servicePlatform == 1) {
									newVal = `${newValText}（收款商户：${newVal.uniCompanyName}）`
								}else {
									newVal = `${newValText}`
								}
								
								if(oldVal.servicePlatform == 1) {
									oldVal = `${oldValText}（收款商户：${oldVal.uniCompanyName}）`
								}else {
									oldVal = `${oldValText}`
								}
								
								isChange = newVal == oldVal ? false : true
							}
                            changeTableData.push({
                                changeItemName: this.changeContentKeys[key],
                                keyVal: key,
                                newVal: newVal,
                                oldVal: oldVal,
                                isChange: isChange
                            })
                        }
                    }
                    this.changeTableData = changeTableData.filter(res=>{
                        return res.isChange
                    })
                    this.title = row.type == 0 ? '项目变更内容' : '合同变更内容'
                    this.dialogVisible = true
                } catch (error) {
                    console.log(error);
                }
                
            },
            arraysEqual (arr1, arr2) {
                const list1 = Array.isArray(arr1) ? arr1 : []
                const list2 = Array.isArray(arr2) ? arr2 : []
                if(list1.length !== list2.length) {
                    return true
                }
                for (let index = 0; index < list1.length; index++) {
                    const item = list1[index] || {};
                    let targetItem = list2.find(res=>{
                        return res.targetCompanyId == item.targetCompanyId && res.rate == item.rate
                    })
                    if(!targetItem) {
                        return true
                    }
                    // 递归比较下级：任一下级有变化则整体有变化
                    if(this.arraysEqual(item.childList, targetItem.childList)) {
                        return true
                    }
                }
                return false
            },
            refresh () {
                this.pageParam.freshCtrl++
            }
		}
	}
</script>

<style lang="scss" scoped>
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .income-detail {
        display: flex;
        flex-direction: column;
        width: 100%;
        .income-group {
            display: flex;
            flex-direction: column;
            width: 100%;
            & + .income-group {
                margin-top: 10px;
            }
        }
        .income-card {
            display: flex;
            align-items: center;
            width: 100%;
            padding: 8px 12px;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            background: #F2F6FC99;
            font-size: 13px;
            color: #303133;
            .card-name {
                flex: 1;
                word-break: break-all;
            }
            .card-ratio {
                flex-shrink: 0;
                margin-left: 12px;
                font-weight: 700;
                white-space: nowrap;
            }
        }
        .income-card-child {
            background: #FAFBFD;
            border: 1px solid #E4E7ED;
            border-left: 3px solid #A0CFFF;
        }
        .children-wrap {
            margin-left: 6px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
        .child-wrap {
            position: relative;
            margin-top: 8px;
            padding-left: 24px;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: -8px;
                bottom: 0;
                width: 2px;
                background: #A0CFFF;
            }
            &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                width: 24px;
                height: 2px;
                margin-top: -1px;
                background: #A0CFFF;
            }
            &:last-child::before {
                bottom: auto;
                height: calc(50% + 8px);
            }
        }
    }
</style>
